import React, { useEffect, useState } from 'react'
import './index.scss'




interface IProps {
    data: any

    //点击书籍跳deeplink或者弹出pc弹窗
    handleDeeplink: (bookId?: string) => void
}

const Index: React.FC<IProps> = (props) => {
    const { data = {}, handleDeeplink } = props



    return <div className='popular_item' onClick={() => handleDeeplink(data.book_id)}>
        <div className='popular_item_pic'>
           
            <img src={data?.book_pic} alt=""  />
        </div>
        <div className='popular_item_info'>
            <div className='popular_item_info_title'>{data?.book_title || ''}</div>
            <div className='popular_item_info_chapter'>Chapter1</div>
        </div>




    </div>
}


export default Index